import { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Section } from 'UIPackage/FormModule/components/Section';
import { Row } from 'UIPackage/FormModule/components/Row';

import styles from './MeasureKnoChangeHistory.module.scss';
import { changeKnoGetMeasureHistoryChanges } from '../actions/ChangeKnoInMeasureActions';
import { getHistoryChangesItems } from '../selectors/changeKnoInMeasureSelectors';
import { IMeasureKnoChangeHistoryItem } from '../../APIPackage/KnmModule/interfaces/IMeasureKnoChangeHistoryItem';
import { formatDate } from '../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_ISO_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from '../../CorePackage/MainModule/constants/dateFormats';

const PAGE_SIZE = 10;

interface IMeasureKnoChangeHistoryProps {
  historyChangesItems: IMeasureKnoChangeHistoryItem[];
}

const MeasureKnoChangeHistoryWithoutStore = ({ historyChangesItems }: IMeasureKnoChangeHistoryProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const blockRef = useRef<HTMLDivElement>(null);
  const [itemsPage, setItemsPage] = useState<number>(0);
  const lastVisibleItemsNumber = (itemsPage + 1) * PAGE_SIZE;

  useEffect(() => {
    dispatch(changeKnoGetMeasureHistoryChanges());
  }, [dispatch]);

  const handleLoadMoreButtonClick = useCallback(() => setItemsPage(prev => prev + 1), []);

  const isLoadMoreButtonVisible = historyChangesItems.length > lastVisibleItemsNumber;

  return (
    <Section title="История изменений" id="changeMeasureKnoHistory">
      <div ref={blockRef} />

      {historyChangesItems.length > 0 ? (
        <Row>
          {historyChangesItems.map((historyItem, index) => {
            if (index > lastVisibleItemsNumber - 1) {
              return null;
            }

            return (
              <KnmCollapse
                key={historyItem.id}
                title={`Обновлено - ${historyItem.user?.fullName} (${historyItem.user?.username}) ${formatDate({
                  date: historyItem.created,
                  dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                  parseFormat: DATE_FORMAT_ISO_FNS,
                })} (МСК)`}
              >
                <>
                  <div className={styles.Patch}>
                    Значение поля &quot;Основание изменения&quot; добавлено: {historyItem.reasonChangeKno}
                    <br />
                    Значение поля &quot;{historyItem.measureType === 'DECISION' ? 'Номер решения' : 'Номер мероприятия'}
                    &quot; добавлено: {historyItem.erpId}
                    <br />
                    Значение поля &quot;КНО&quot; добавлено: {historyItem.knoName}
                  </div>
                </>
              </KnmCollapse>
            );
          })}
        </Row>
      ) : (
        <Row>Сведения отсутствуют</Row>
      )}

      {isLoadMoreButtonVisible && (
        <Button type="button" text="Показать еще" color="load" onClick={handleLoadMoreButtonClick} />
      )}
    </Section>
  );
};

const mapStateToProps = (state: IRootState) => ({
  historyChangesItems: getHistoryChangesItems(state),
});

export const MeasureKnoChangeHistory = connect(mapStateToProps)(MeasureKnoChangeHistoryWithoutStore);
